function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 421.03 421.03",
  style: {
    "enableBackground": "new 0 0 421.03 421.03"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#545465"
  },
  d: "M289.479,34.106C270.08,10.515,235.697,0.02,210.515,0c-25.182,0.02-59.565,10.515-78.964,34.106 c-47.707,58.016-60.32,253.67-60.32,253.67h139.284h139.284C349.799,287.776,337.186,92.122,289.479,34.106z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#545465"
  },
  d: "M309.22,269.683h-2.193c-18.317,0-29.887-3.589-37.289-9.243v-0.153 c-12.762-9.915-12.803-26.124-12.803-41.037h-0.358v-15.37h-92.124v15.354c0,12.506-0.157,25.863-7.699,35.713 c-0.485,0.637-0.936,1.29-1.485,1.896c-1.088,1.194-2.303,2.327-3.665,3.386c-7.388,5.783-19.043,9.454-37.599,9.454h-2.193 c-39.976,0-72.384,32.407-72.384,72.384v59.223c0,10.902,8.838,19.741,19.741,19.741h302.695c10.903,0,19.741-8.839,19.741-19.741 v-59.223C381.603,302.09,349.196,269.683,309.22,269.683z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#E4EBF0"
  },
  d: "M57.898,293.886c32.892,43.556,88.959,72.252,152.617,72.252s119.725-28.696,152.617-72.252 c-13.255-14.821-32.465-24.203-53.913-24.203h-2.193c-18.317,0-29.887-3.589-37.289-9.243v-0.153 c-12.762-9.915-12.803-26.124-12.803-41.037h-0.358v-15.37h-92.124v15.354c0,12.506-0.157,25.863-7.699,35.713 c-0.485,0.637-0.936,1.29-1.485,1.896c-1.088,1.194-2.303,2.327-3.665,3.386c-7.388,5.783-19.043,9.454-37.599,9.454h-2.193 C90.362,269.683,71.152,279.066,57.898,293.886z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D0D7DC"
  },
  d: "M164.453,212.357c11.703,13.276,39.297,54.145,122.127,55.372c-0.021-0.018-0.044-0.04-0.065-0.057 c-7.164-1.605-12.651-4.081-16.777-7.233v-0.153c-12.762-9.915-12.803-26.124-12.803-41.037h-0.358v-15.37h-72.384l-19.741,8.154 V212.357z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFE1B2"
  },
  d: "M126.179,104.534c-0.692,4.352-1.163,8.886-1.163,13.801c0,52.696,45.827,118.446,85.544,118.446 s85.544-65.75,85.544-118.446c0-4.915-0.471-9.45-1.163-13.801c-27.881-7.969-52.047-12.412-84.381-12.412 S154.06,96.565,126.179,104.534z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#E4EBF0"
  },
  d: "M294.941,104.534c-27.881-7.969-52.047-12.412-84.381-12.412s-56.5,4.443-84.381,12.412 c-0.692,4.352-1.163,8.886-1.163,13.801c0,1.524,0.122,4.605,0.122,4.605c24.804-5.62,60.284-10.114,85.422-10.144 c25.138,0.031,60.617,4.524,85.422,10.144c0,0,0.122-3.081,0.122-4.605C296.104,113.42,295.633,108.886,294.941,104.534z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D0D7DC"
  },
  d: "M209.826,335.347c-37.345,0-71.346-26.848-84.603-66.806c-0.858-2.587,0.543-5.382,3.13-6.24 c2.59-0.861,5.379,0.546,6.24,3.13c11.914,35.915,42.149,60.045,75.233,60.045c33.091,0,63.326-24.136,75.24-60.058 c0.855-2.587,3.656-3.991,6.237-3.133c2.59,0.858,3.991,3.65,3.133,6.237C281.181,308.492,247.178,335.347,209.826,335.347z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D0D7DC"
  },
  d: "M209.826,346.689c-1.819,0-3.29-1.472-3.29-3.29v-12.987c0-1.819,1.472-3.29,3.29-3.29 s3.29,1.472,3.29,3.29v12.987C213.116,345.217,211.644,346.689,209.826,346.689z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 203.246,
  y: 343.572,
  style: {
    "fill": "#FFFFFF"
  },
  width: 13.161,
  height: 65.803
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 190.085,
  y: 356.733,
  style: {
    "fill": "#FFFFFF"
  },
  width: 39.482,
  height: 13.161
}))), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

export default __webpack_public_path__ + "static/media/6.7f7e7e2a.svg";
export { SvgComponent as ReactComponent };